import { MediaLicense } from '@/declarations/models/MediaLicense';

// Helper to map string to MediaLicense enum value
export function mapTitleToMediaLicense(title?: string | null): MediaLicense | undefined {
  if (!title) return undefined;
  const entry = Object.entries(MediaLicense).find(([, value]) => value === title);
  return entry ? (MediaLicense as any)[entry[0]] : undefined;
}
